// extracted by mini-css-extract-plugin
export default {"card":"Card_card__qbJO9","disabled":"Card_disabled__nFDDl","labelContainer":"Card_labelContainer__A6hgt","icon":"Card_icon__2-P8c","label":"Card_label__DNrDn"};